const admin = {
  forecast: {
    title: 'Forecast',
    viewtitle: 'Forecast'
  }
}

export default admin
